<div class="breadcrumb-container" [ngClass]="{ 'breadcrumb-container-compact': compactSidebar }" id="breadcrumb">
  <div class="breadcrumb-component">
    <app-breadcrumb
      [parents]="breadcrumbParents"
      [self]="breadcrumbSelf">
    </app-breadcrumb>
  </div>
  <div class="breadcrumb-menu d-flex">
    <!--CREATE-->
    <div class="breadcrumb-button-icon-container cursor-pointer"
         *ngIf="rightModel.taskCreate.hasRight()"
         (click)="openImportDialog()">
      <a class="btn-setting d-flex align-items-center" title="{{'COMMON_BUTTON_IMPORT' | translate}}">
        <i class="icomoon icomoon-csv-import"></i>
        <span class="breadcrumb-button-text-visible">{{'COMMON_BUTTON_IMPORT' | translate}}</span>
      </a>
    </div>
    <div *ngIf="rightModel.taskCreate.hasRight()"
         class="breadcrumb-button-icon-container cursor-pointer negative-margin-right"
         uiSref="Admin.TaskCreate">
      <a class="btn-setting d-flex align-items-center" title="{{'COMMON_BUTTON_ADD' | translate}}">
        <i class="icomoon icomoon-add"></i>
        <span class="breadcrumb-button-text-visible">{{'COMMON_BUTTON_ADD' | translate}}</span>
      </a>
    </div>
  </div>
</div>
<div class="breadcrumb-placeholder"></div>
<div class="container-horizontal-padding container-vertical-padding animated fadeIn">

  <div class="card">

    <div class="card-header">
      {{'TASK_PANEL_HEADING_LIST' | translate}}

      <div class="card-actions">
        <a class="btn-setting cursor-pointer" (click)="toggleSearch()" title="{{'COMMON_SHOW_SEARCH_HINT' | translate}}"><i class="icomoon icomoon-search"></i></a>
      </div><!-- /.card-actions -->
    </div>

    <div class="card-body border-bottom" *ngIf="showSearch" appHighlightContainer>
      <div class="row form-group">
        <div class="col">
          <label class="search-label">{{'TASK_SEARCH_FIELD_ID' | translate}}</label>
          <input type="text" class="form-control" placeholder="{{'TASK_SEARCH_FIELD_ID' | translate}}"
                 maxlength="{{UiConstants.maxInputLongLength}}"
                 (keyup.enter)="onSearchClicked()"
                 [textMask]="{mask: InputMask.NATURAL_INTEGER, guide: false}"
                 [(ngModel)]="searchModel.id" name="id" id="id" #id="ngModel">
        </div>
        <div class="col">
          <label class="search-label">{{'COMMON_NAME' | translate}}</label>
          <input type="text" class="form-control" placeholder="{{'COMMON_NAME' | translate}}"
                 maxlength="{{UiConstants.maximumVarcharLength}}"
                 (keyup.enter)="onSearchClicked()"
                 [(ngModel)]="searchModel.name" name="name" id="name" #name="ngModel">
        </div>
        <div class="col">
          <label class="search-label">{{'TASK_SEARCH_FIELD_DISABLED' | translate}}</label>
          <select class="form-control" [compareWith]="SelectUtils.compareObjects" [(ngModel)]="searchModel.disabled"
                  id="disabled" name="disabled" #disabled="ngModel">
            <option *ngFor="let item of taskDisabledItems" [ngValue]="item">{{item.text}}</option>
          </select>
        </div>
        <div class="col">
          <label class="search-label">{{'TASK_SEARCH_FIELD_SHOW_ON_DASHBOARD' | translate}}</label>
          <select class="form-control" [(ngModel)]="searchModel.showOnDashboard"
                  id="showOnDashboard" name="showOnDashboard" #showOnDashboard="ngModel">
            <option *ngFor="let item of searchBooleanItemObjects" [ngValue]="item.value">{{item.stringKey | translate}}</option>
          </select>
        </div>
        <div class="col">
          <label class="search-label">{{'FORM_CREATE_HELPDESK_ENABLED' | translate}}</label>
          <select class="form-control" [(ngModel)]="searchModel.helpdeskEnabled"
                  id="helpdeskEnabled" name="helpdeskEnabled" #helpdeskEnabled="ngModel">
            <option *ngFor="let item of searchBooleanItemObjects" [ngValue]="item.value">{{item.stringKey | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-12 d-flex justify-content-md-end align-items-end px-0">
        <div class="btn-group" role="group">
          <button type="button" (click)="onSearchReset()" class="btn btn-outline-primary search-button mr-1">
            {{'COMMON_BUTTON_SEARCH_DELETE' | translate}}
          </button>
          <button type="button" (click)="onSearchClicked()" class="btn btn-primary search-button">
            {{'COMMON_BUTTON_SEARCH' | translate}}
          </button>
        </div>
      </div>
    </div> <!-- ./card-body end -->

    <div class="card-body">
      <table class="table table-striped table-bordered">
        <thead>
        <tr>
          <th class="table-sorter-header fit hidden-xs-down"><app-table-field-sorter [orderField]="Task.OrderField.ID" [orderType]="queryModel.getOrderType(Task.OrderField.ID)" (orderChange)="orderBy($event)" [text]="'COMMON_TABLE_HEADER_ID' | translate"></app-table-field-sorter></th>
          <th class="table-sorter-header fit hidden-md-down"><app-table-field-sorter [orderField]="Task.OrderField.EXPLICIT_ORDER_NUMBER" [orderType]="queryModel.getOrderType(Task.OrderField.EXPLICIT_ORDER_NUMBER)" (orderChange)="orderBy($event)" [text]="'TASK_TABLE_HEADER_ORDER' | translate"></app-table-field-sorter></th>
          <th class="table-sorter-header long"><app-table-field-sorter [orderField]="Task.OrderField.NAME" [orderType]="queryModel.getOrderType(Task.OrderField.NAME)" (orderChange)="orderBy($event)" [text]="'COMMON_NAME' | translate"></app-table-field-sorter></th>
          <th class="table-sorter-header w-15 hidden-lg-down"><app-table-field-sorter [orderField]="Task.OrderField.CREATION_TIME" [orderType]="queryModel.getOrderType(Task.OrderField.CREATION_TIME)" (orderChange)="orderBy($event)" [text]="'COMMON_TABLE_HEADER_CREATION_TIME' | translate"></app-table-field-sorter></th>
          <th class="table-sorter-header w-15 hidden-md-down"><app-table-field-sorter  [orderField]="Task.OrderField.UPDATE_TIME" [orderType]="queryModel.getOrderType(Task.OrderField.UPDATE_TIME)" (orderChange)="orderBy($event)" [text]="'COMMON_TABLE_HEADER_UPDATE_TIME' | translate"></app-table-field-sorter></th>
          <th class="table-sorter-header w-table-options-menu"><app-table-sorter-no-op></app-table-sorter-no-op></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let task of taskList | paginate: {
                                                      itemsPerPage: queryModel.itemsPerPage,
                                                      currentPage: queryModel.currentPage,
                                                      totalItems: queryModel.currentNumberOfItems }" [disabledTableRow]="task.disabled">
          <td class="fit hidden-xs-down align-middle">{{task.taskId}}</td>
          <td class="fit hidden-md-down align-middle">{{task.explicitOrderNumber}}</td>
          <td class="responsive-table-column long">
            <div class="d-flex justify-content-start align-items-center">
              <app-type-icon [icon]="task.icon" class="mr-05"></app-type-icon>
              <div>
                <a *ngIf="rightModel.taskUpdate.hasRight()"
                   class="id-text cursor-pointer"
                   href="#" onclick="return false"
                   uiSref="Admin.TaskEdit"
                   [uiParams]="{ id: task.taskId }"
                   title="{{'COMMON_BUTTON_EDIT' | translate}}">
                  {{task.name}}
                </a>
                <span *ngIf="!rightModel.taskUpdate.hasRight()">{{task.name}}</span>
                <div class="table-text-subtitle">
                  {{task.externalId}}
                </div>
              </div>
            </div>
          </td>
          <td class="responsive-table-column hidden-lg-down align-middle">{{task.creationTime.toUtcIsoString() | date:'short'}}</td>
          <td class="responsive-table-column hidden-md-down align-middle">{{task.updateTime.toUtcIsoString() | date:'short'}}</td>
          <td class="align-middle">
            <app-table-options-menu>
              <app-dropdown-item
                *ngIf="rightModel.taskUpdate.hasRight()"
                [iconClass]="'icomoon-modify'"
                [titleStringKey]="'COMMON_BUTTON_EDIT'"
                class="cursor-pointer"
                uiSref="Admin.TaskEdit"
                [uiParams]="{ id: task.taskId }">
              </app-dropdown-item>
              <app-dropdown-item
                *ngIf="task.disabled && rightModel.taskDisable.hasRight()"
                [iconClass]="'icomoon-enable'"
                [titleStringKey]="'COMMON_BUTTON_ENABLE'"
                [itemType]="DropdownItemType.ENABLE"
                class="cursor-pointer"
                (click)="setDisabled($event, task, false)">
              </app-dropdown-item>
              <app-dropdown-item
                *ngIf="!task.disabled && rightModel.taskDisable.hasRight()"
                [iconClass]="'icomoon-disable'"
                [titleStringKey]="'COMMON_BUTTON_DISABLE'"
                [itemType]="DropdownItemType.DISABLE"
                class="cursor-pointer"
                (click)="setDisabled($event, task, true)">
              </app-dropdown-item>
            </app-table-options-menu>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th class="table-sorter-header fit hidden-xs-down"><app-table-field-sorter [orderField]="Task.OrderField.ID" [orderType]="queryModel.getOrderType(Task.OrderField.ID)" (orderChange)="orderBy($event)" [text]="'COMMON_TABLE_HEADER_ID' | translate"></app-table-field-sorter></th>
          <th class="table-sorter-header fit hidden-md-down"><app-table-field-sorter [orderField]="Task.OrderField.EXPLICIT_ORDER_NUMBER" [orderType]="queryModel.getOrderType(Task.OrderField.EXPLICIT_ORDER_NUMBER)" (orderChange)="orderBy($event)" [text]="'TASK_TABLE_HEADER_ORDER' | translate"></app-table-field-sorter></th>
          <th class="table-sorter-header long"><app-table-field-sorter [orderField]="Task.OrderField.NAME" [orderType]="queryModel.getOrderType(Task.OrderField.NAME)" (orderChange)="orderBy($event)" [text]="'COMMON_NAME' | translate"></app-table-field-sorter></th>
          <th class="table-sorter-header w-15 hidden-lg-down"><app-table-field-sorter [orderField]="Task.OrderField.CREATION_TIME" [orderType]="queryModel.getOrderType(Task.OrderField.CREATION_TIME)" (orderChange)="orderBy($event)" [text]="'COMMON_TABLE_HEADER_CREATION_TIME' | translate"></app-table-field-sorter></th>
          <th class="table-sorter-header w-15 hidden-md-down"><app-table-field-sorter  [orderField]="Task.OrderField.UPDATE_TIME" [orderType]="queryModel.getOrderType(Task.OrderField.UPDATE_TIME)" (orderChange)="orderBy($event)" [text]="'COMMON_TABLE_HEADER_UPDATE_TIME' | translate"></app-table-field-sorter></th>
          <th class="table-sorter-header  w-table-options-menu"><app-table-sorter-no-op></app-table-sorter-no-op></th>
        </tr>
        </tfoot>
      </table>
      <app-table-paging
        [currentNumberOfItems]="queryModel.currentNumberOfItems"
        [totalNumberOfItems]="queryModel.totalNumberOfItems"
        [itemsPerPage]="queryModel.itemsPerPage"
        (pageChange)="pageChanged($event)"
        (itemsPerPageChange)="itemsPerPageChanged($event)">
      </app-table-paging>
    </div>
  </div>
</div>
